import styled from 'styled-components';
import { media } from '@prisjakt/ui-base';

export const PriceHistoryLinkWrapper = styled.div`
  display: none;

  ${media.largeUp`
      display: block;
    `}
`;
